import React, { useState } from "react";
import { Form, Button, Row, Col, Container } from "react-bootstrap";
import {CreateUserDto, UserBasic} from "../../../service/types/types";
import { UserService } from "../../../service/users.service";
import { FeedbackModal } from "../../common/feedback.modal";
import {UserBasicService} from "../../../service/users-basic.service";

export default function CreateUserBasic() {
  const [formData, setFormData] = useState<UserBasic>({
    rut: "",
    nombre: "",
    correo: "",
    cargo: "",
    zona: ""
  });

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.rut || !formData.nombre || !formData.correo || !formData.cargo || !formData.zona) {
      setModalType("error");
      setModalMessage("Por favor, completa todos los campos.");
      setShowModal(true);
      return;
    }

    setLoading(true);
    try {
      await UserBasicService.create(formData);
      setModalType("success");
      setModalMessage("Usuario creado correctamente");
      setFormData({
        rut: "",
        nombre: "",
        correo: "",
        cargo: "",
        zona: ""
      });
    } catch (error: any) {
      setModalType("error");
      setModalMessage(error?.response?.data?.message || "Error al crear usuario");
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (
    <Container className="py-5">
      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
      />

      <div className="mb-4">
        <h2>Crear Usuario</h2>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>RUT</Form.Label>
              <Form.Control
                type="text"
                name="rut"
                value={formData.rut}
                onChange={handleChange}
                placeholder="Ej: 12345678-9"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Nombre completo"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Correo</Form.Label>
              <Form.Control
                type="correo"
                name="correo"
                value={formData.correo}
                onChange={handleChange}
                placeholder="ejemplo@correo.com"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Cargo</Form.Label>
              <Form.Control
                type="text"
                name="cargo"
                value={formData.cargo}
                onChange={handleChange}
                placeholder="Ej: Técnico"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Zona</Form.Label>
              <Form.Control
                type="text"
                name="zona"
                value={formData.zona}
                onChange={handleChange}
                placeholder="Ej: zona Norte"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col md={12}>
            <Button
              variant="success"
              type="submit"
              disabled={loading}
              className="me-2"
            >
              {loading ? "Creando..." : "Crear Usuario"}
            </Button>
            <Button
              variant="secondary"
              onClick={() => setFormData({ rut: "", nombre: "", correo: "", cargo: "", zona: ""})}
            >
              Limpiar
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
